import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import Textfield from 'britive-design-system/core/components/textfield'
import Button from 'britive-design-system/core/components/button'
import Tooltip from 'britive-design-system/core/components/tooltip'
import Table from 'britive-design-system/core/components/table'
import Spinner from 'britive-design-system/core/components/spinner'
import CopyButton from 'secret-manager-ui/core/components/copyButton/CopyButton'
import { getIDs } from 'action_creators/notification-mediums'
import deleteIcon from 'static/images/delete-icon.svg'
import toast from 'utils/toast'

const styles = {
  channelsContainer: {
    display: 'flex',
    gap: '10px',
    flexDirection: 'column',
    alignItems: 'baseline',
  },
  channelNamesContainer: {
    display: 'flex',
    alignItems: 'end',
    gap: '10px',
  },
}

const ChannelNamesIdsList = ({ notificationMedium, setNotificationMedium }) => {
  const dispatch = useDispatch()
  const { data: IDsData, loading: IDsLoading } = useSelector(
    state => state.notificationMediumsReducer?.getIds || { data: [] }
  )
  const [slackAppChannelsNames, setSlackAppChannelsNames] = useState([])
  const [slackAppChannelsList, setSlackAppChannelsList] = useState([])

  useEffect(() => {
    if (IDsData?.data) {
      const mappedArray = Object.entries(IDsData?.data || {})
        .filter(([key]) => key !== 'channels_not_found')
        .map(([channelName, id]) => ({ channelName, id }))

      setSlackAppChannelsList(mappedArray)
      const newIDs = mappedArray?.map(item => item?.id)
      const mergedIDs = [...(notificationMedium?.channels || []), ...newIDs].filter(
        (id, index, self) => id && self.indexOf(id) === index
      )

      setNotificationMedium(prev => ({
        ...prev,
        channels: mergedIDs,
      }))
    }
  }, [IDsData])
  const slackAppColumns = [
    {
      field: 'channelName',
      headerName: 'Channel Name',
      width: '180px',
    },
    {
      headerName: 'Channel ID',
      width: '180px',
      renderColumn: row => {
        return (
          <div style={styles.channelNamesContainer}>
            {row?.id}
            <CopyButton textToCopy={row?.id} />
          </div>
        )
      },
    },
    {
      headerName: 'Action',
      renderColumn: (row, value, index) => {
        return (
          <div className="table-cell">
            <Tooltip title="Delete" position="top">
              <div
                className="action-button"
                onClick={() => {
                  setSlackAppChannelsList(prevList => {
                    const updatedList = [...prevList]
                    const deletedChannel = updatedList.splice(index, 1)[0]

                    if (deletedChannel?.id) {
                      setNotificationMedium(prev => {
                        const updatedChannels = prev.channels.filter(
                          id => id !== deletedChannel.id
                        )
                        return {
                          ...prev,
                          channels: updatedChannels,
                        }
                      })
                    }
                    return updatedList
                  })
                }}
              >
                <img src={deleteIcon} alt="Delete" />
              </div>
            </Tooltip>
          </div>
        )
      },
    },
  ]

  return (
    <>
      {IDsLoading && <Spinner size={'medium'} message={'Loading...'} overlay />}
      <div style={styles.channelsContainer}>
        <Textfield
          label="Channel Names"
          type="text"
          helperText={'Comma separated list of channel names'}
          value={slackAppChannelsNames?.join(',') || ''}
          width="548px"
          onChange={e => {
            const channels = e.target.value.length
              ? e.target.value.split(',').map(channel => channel.trim())
              : []
            setSlackAppChannelsNames(channels)
          }}
          error={IDsData?.data?.channels_not_found?.length > 0}
          errorMsg={`Channels Not Found: ${IDsData?.data?.channels_not_found?.join(
            ', '
          )}`}
        />
        <Button
          variant="secondary"
          onClick={async () => {
            try {
              await dispatch(getIDs(notificationMedium.id, slackAppChannelsNames))
            } catch (e) {
              const error = e?.response?.data?.message || 'Failed to get ID(s).'
              toast({ title: error, type: 'error', time: 'normal' })
            }
          }}
        >
          Get ID(s)
        </Button>
      </div>
      {slackAppChannelsList?.length > 0 && (
        <div>
          <Table
            resizableColumns
            columns={slackAppColumns || []}
            rows={slackAppChannelsList || []}
          />
        </div>
      )}
    </>
  )
}

ChannelNamesIdsList.propTypes = {
  notificationMedium: PropTypes.object,
  setNotificationMedium: PropTypes.func,
}

export default ChannelNamesIdsList
